export const CART_ADD_BY_RECIPE = 'CART_ADD_BY_RECIPE';
export const CART_ADD_BY_MEAL = 'CART_ADD_BY_MEAL';
export const CART_ADD_BY_DAY = 'CART_ADD_BY_DAY';
export const CART_ADD_BY_WEEK = 'CART_ADD_BY_WEEK';
export const CART_UPDATE = 'CART_UPDATE';
export const CART_CLEAR = 'CART_CLEAR';
